// Fixture messages shared by the communication-channel teasers. Kept apart from
// the components so each preview file exports components only (react-refresh).
export interface Message {
  initials: string;
  avatarColor: string;
  sender: string;
  channel: "SMS" | "Email";
  timestamp: string;
  body: string;
}

export const SMS_MESSAGE: Message = {
  initials: "AD",
  avatarColor: "#52c535",
  sender: "Angel Donin",
  channel: "SMS",
  timestamp: "Yesterday at 4:58 PM",
  body: "Hello Angel Donin, Thank you for your recent interest in Lemon Grove Apartments. We're excited to help you find your next home! Our community features a range..."
};

export const EMAIL_MESSAGE: Message = {
  initials: "AM",
  avatarColor: "#00b7f4",
  sender: "Alberta McGlynn",
  channel: "Email",
  timestamp: "Yesterday at 4:58 PM",
  body: "Hi, I saw the 2-bedroom unit at Lemon Grove on Zillow and wanted to check if it's still available. I'd love to schedule a tour this weekend if possible."
};
